type Choice = {
	display_name: string
	value: string
}

export const toOptions = (choices: Choice[] | undefined) =>
	choices?.map((choice) => ({ label: choice.display_name, value: choice.value }))
